import React, { Component } from 'react'
import NavigationItems from './Components/NavigationItems'
import PageHeader from './Components/PageHeader'
import Footer from './Components/Footer'
import axios from 'axios'
import Base from './Config'
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';


export default class Price extends Component {
    constructor(){
        super()
        this.state={
            data:[],
            next:null,
            prev:null,
            loading:true,

            exp:'',
            insp:'',
        }
    }

    loading=(args)=>{
        this.setState({
            loading:args
        })
    }

    componentDidMount(){
        this.fetchAllData()
    }

    next=()=>{
        this.loading(true)
        axios.get(
          this.state.next.replace(/^http:\/\//i, 'https://'),
          { 
              headers: { 
                'Authorization': 'Token '+localStorage.getItem('Token'),
              } 
          }
        ).then(response =>{
          this.setState({
            data:response.data.results,
            next:response.data.next,
            prev:response.data.previous,
            loading:false, 

          })
        })
        .catch(error =>{
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    prev=()=>{
        this.loading(true)
        axios.get(
          this.state.prev.replace(/^http:\/\//i, 'https://'),
          { 
              headers: { 
                  'Authorization': 'Token '+localStorage.getItem('Token'),
              } 
          }
        ).then(response =>{
          this.setState({
            data:response.data.results,
            next:response.data.next,
            prev:response.data.previous,
            loading:false,
          })
        })
        .catch(error =>{
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    fetchAllData(){
        this.loading(true)
        axios.get(
            Base.url + 'PriceList/',
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            // console.log('Response all :', response.data.results);
            // console.log('Response all :', response.data.results[0].price);
            // console.log('Response all :', response.data.results[1].price);

            this.setState({
                data: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                exp:response.data.results[0].price,
                insp:response.data.results[1].price,
                loading:false,
            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 3000);
        })
    }


    updateExpress=()=>{


        this.loading(true)
        // console.log('PriceList/');
        // console.log(this.state.exp)
        // console.log(!isNaN(this.state.exp))

        if(isNaN(this.state.exp)){
            NotificationManager.warning('Expected : ', 'Numeric value for Express service charge', 3000)

        }

        
        var bodyFormData1 = new FormData();
        bodyFormData1.set('new_price', this.state.exp);
        bodyFormData1.set('keyword', 'express_service');

        


        axios.put(
            Base.url + 'PriceList/',
            bodyFormData1,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
        .then(response =>{
            // console.log('response : ',response);
                if(response.data.Status){
                    NotificationManager.success( response.data.Message,'Success : ',3000)
                    this.fetchAllData()
                    this.loading(false)

                    this.setState({
                        exp:'',
                    })

                }else{
                    // console.log(response.data.Message);
                    NotificationManager.error('Error : ', response.data.Error, 3000)

                    this.loading(false)
                }
        })
        .catch(error=>{
            console.log(error);
        })

        
    }
    updateInspection=()=>{

        if(isNaN(this.state.exp)){
            NotificationManager.warning('Expected : ', 'Neumeric value for Inspection charge', 3000)

            return false
        }


        var bodyFormData2 = new FormData();
        bodyFormData2.set('new_price', this.state.insp);
        bodyFormData2.set('keyword', 'inspection_charge');

        axios.put(
            Base.url + 'PriceList/',
            bodyFormData2,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
        .then(response =>{
            // console.log('response : ',response);
                if(response.data.Status){
                    NotificationManager.success( response.data.Message,'Success : ',3000)
                    this.fetchAllData()
                    this.loading(false)

                    this.setState({
                        insp:'',
                    })

                }else{
                    console.log(response.data.Message);
                    NotificationManager.error('Error : ', response.data.Error, 3000)

                    this.loading(false)
                }
        })
        .catch(error=>{
            console.log(error);
        })

    }
    onChange=(e)=>{
        this.setState ({
            [e.target.name]:e.target.value
        })
    }
    render() {
        return (
            <div>
{/* <NotificationContainer/> */}

                <NavigationItems />
                {/* Main content */}
                <div className="main-content">
                    <PageHeader pageName="Price list" />

                    <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8">
                        <div className="container-fluid">
                            <div className="header-body">
                                {/* Card stats */}
                                <div className="row">
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Page content */}
                    <div className="container-fluid mt--7">
                        <div className="row">
                            <div className="col-xl-8 mb-5 mb-xl-0">
                                <div className="card shadow">
                                    <div className="card-header border-0">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h3 className="mb-0">Price list</h3>
                                            </div>
                                            <div className="col text-right">
                                                {/* <button href="#!" className="btn btn-sm btn-primary" onClick={this.updateCharges}>Update all</button> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="table-responsive">
                                        {/* Projects table */}
                                        <table className="table align-items-center table-flush">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th scope="col">Keyword</th>
                                                    <th scope="col">Price</th>
                                                    <th scope="col">Action</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th scope="row">Express Service</th>
                                                    
                                                    <td>
                                                        {/* <i class="fa fa-check-circle" style="font-size:20px;color:green"></i> */}
                                                        {/* <div className="form-group">
                                                            <div className="input-group input-group-alternative mb-3">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text"><i className /></span>
                                                                </div> */}
                                                                <input name="exp"  onChange={this.onChange} onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()} value={this.state.exp} className="form-control" type="number" />
                                                            {/* </div>
                                                        </div> */}
                                                    </td>
                                                    <td>
                                                        <button href="#!" className="btn btn-sm btn-primary" onClick={this.updateExpress}>Update</button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Inspection Charge</th>
                                                    <td>
                                                        {/* <i class="fa fa-check-circle" style="font-size:20px;color:green"></i> */}
                                                        {/* <div className="form-group">
                                                            <div className="input-group input-group-alternative mb-3">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text"><i className /></span>
                                                                </div> */}
                                                                <input className="form-control"  onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()} name="insp" onChange={this.onChange} value={this.state.insp} type="number" />
                                                            {/* </div> */}
                                                        {/* </div> */}
                                                    </td>
                                                    <td>
                                                        <button href="#!" className="btn btn-sm btn-primary" onClick={this.updateInspection}>Update</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        )
    }
}
